export type AvailabilityLevel = "plenty" | "limited" | "scarce" | "soldout";

export const getAvailabilityLevel = (spots: number): AvailabilityLevel => {
    if (spots >= 10) return "plenty";
    if (spots >= 5) return "limited";
    if (spots >= 1) return "scarce";
    return "soldout";
};

export const AVAILABILITY_COLORS: Record<AvailabilityLevel, string> = {
    plenty: "#22c55e",
    limited: "#f97316",
    scarce: "#ef4444",
    soldout: "#9ca3af",
};

export const AVAILABILITY_LABELS: Record<AvailabilityLevel, string> = {
    plenty: "Plenty of spots – 10+ available",
    limited: "Filling fast – 5–9 seats remaining",
    scarce: "Almost full – only 1–4 seats left",
    soldout: "Fully booked",
};

/**
 * Ceiling the calendar applies to a day's spaces badge, so a wide-open day reads
 * "20+" rather than an exact figure the supplier would rather not advertise.
 */
export const AVAILABILITY_DISPLAY_CAP = 20;

/**
 * A spaces count as the calendar shows it: the exact number, or "20+" once it
 * reaches the cap. Share this everywhere a remaining-spaces figure is rendered —
 * the calendar day badge and the fare rows behind it drew from the same data but
 * formatted it differently, so a day badged "20+" opened onto "34 spaces".
 */
export const formatAvailableSpaces = (spots: number): string =>
    spots >= AVAILABILITY_DISPLAY_CAP ? `${AVAILABILITY_DISPLAY_CAP}+` : `${spots}`;

/**
 * The same count with its noun, e.g. "1 space", "7 spaces", "20+ spaces". Only an
 * exact 1 is singular; a capped count is always plural.
 */
export const formatAvailableSpacesLabel = (spots: number): string =>
    `${formatAvailableSpaces(spots)} ${spots === 1 ? "space" : "spaces"}`;
